<template>
  <div
    class="login_page fillcontain"
    :style="{
      'background-image': 'url(' + this.baseUrl + 'img/bg.jpg) ',
      'background-size': '100% 100%',
    }"
  >
    <!-- <transition name="form-fade" mode="in-out"> -->
    <section class="form_contianer" v-show="showLogin">
      <div class="manage_tip">
        <div class="avatar_box">
          <img :src="this.baseUrl + 'img/logo.png'" alt="logo" />
        </div>
        <!-- <p>基础信息监控平台</p> -->
      </div>

      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        @keydown.enter.native="submitForm('loginForm')"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            prefix-icon="el-icon-user-solid"
            placeholder="用户名"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="密码"
            prefix-icon="el-icon-more"
            v-model="loginForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('loginForm')"
            class="submit_btn"
            >登录</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            @click="resetForm('loginForm')"
            class="submit_btn"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <p class="tip">默认账户密码均为admin</p>
      <!-- <p class="tip">温馨提示：</p>
      <p class="tip">未登录过的新用户，自动注册</p>
      <p class="tip">注册过的用户可凭账号密码登录</p> -->
    </section>
    <!-- </transition> -->
  </div>
</template>

<script>
import { Url } from "../config/env";
// import { login } from "@/api/getData";

import { getAdminInfo } from "@/api/getData";
// import {mapActions, mapState} from 'vuex'

export default {
  data() {
    return {
      loginForm: {
        username: "admin",
        password: "admin",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      showLogin: true,
      baseUrl: Url,
    };
  },
  mounted() {
    this.showLogin = true;
    // if (!this.adminInfo.id) {
    //   this.getAdminData();
    // }
  },
  computed: {
    // ...mapState(['adminInfo']),
  },
  methods: {
    // ...mapActions(['getAdminData']),
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 验证密码有效性;
          const { data } = await getAdminInfo();
          if (this.loginForm.password == data.data[this.loginForm.username]) {
            sessionStorage.setItem("logon", 1);
            this.$message({
              type: "success",
              message: "登录成功",
            });
            this.$router.push("/home");
          } else {
            sessionStorage.setItem("logon", 0);
            this.$message.error("请输入正确的用户名密码");
          }
          // this.$router.push("/home");
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  watch: {
    adminInfo: function (newValue) {
      if (newValue.id) {
        this.$message({
          type: "success",
          message: "检测到您之前登录过，将自动登录",
        });
        this.$router.push("manage");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../style/mixin";
// .login_page {
// background: url("../static/bg.jpg") no-repeat;
// background-size: 100% 100%;
// }
.manage_tip {
  position: absolute;
  width: 100%;
  top: -100px;
  left: 0;
  p {
    font-size: 20px;
    color: #fff;
  }
}
.avatar_box {
  width: 100px;
  height: 100px;
  // border: 1px solid #eee;
  // border-radius: 50%;
  position: absolute;
  left: 10%;
  top: -50%;
  transform: translate(-50%);
  // padding: 10px;
  // box-shadow: 0 0 10px;
  img {
    widows: 100%;
    height: 100%;
    border-radius: 5%;
    // background-color: #eee;
  }
}
.form_contianer {
  .wh(320px, 300px);
  .ctp(320px, 210px);
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  top: 20%;
  left: 45%;
  background-color: rgba(6, 38, 70, 0.1);
  // transform: translate(-50%, -50%);
  .submit_btn {
    width: 100%;
    font-size: 16px;
  }
}
.tip {
  font-size: 12px;
  color: red;
}
.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 1s;
}
.form-fade-enter,
.form-fade-leave-active {
  transform: translate3d(0, -50px, 0);
  opacity: 0;
}
</style>
